import HttpUtil from "@/utils/HttpUtil";

/**
 * 功能模块服务
 */
export default {
    //tree数据
    treeData(enable,menuType){
        return new Promise((resolve,reject)=>{
            HttpUtil.get("/data-center-provider/funcMod/treeData?enable="+((enable===null||enable === undefined)?"":enable)+'&menuType='+menuType).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //根据ID获取
    getById(id){
        return new Promise((resolve,reject)=>{
            HttpUtil.get("/data-center-provider/funcMod/info/"+(id)).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //创建模块
    create(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/funcMod/create",params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //更新模块
    update(id,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/funcMod/update/" + id,params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //分配模块
    ecModGrantUpdate(ecId,modIds,menuType){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/funcMod/ecModGrant/update/"+ecId,{
                grantMods: modIds.join(","),
                menuType: menuType
            }).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //分配模块列表
    ecModGrantList(ecId,menuType){
        return new Promise((resolve,reject)=>{
            HttpUtil.get("/data-center-provider/funcMod/ecGrantedMod/list/"+ecId+'?menuType='+menuType).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //删除模块
    deleteMod(modId){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/funcMod/delete/"+modId).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    }
}
